module.exports = "/images/pillWhiteTagLonger_v2.png?a863b3e22ee81e5d820f20201ba4fbc6";